// extracted by mini-css-extract-plugin
export var closeButton = "close-button-module--closeButton--xvVV9";
export var icon = "close-button-module--icon--mocsE";
export var tab = "close-button-module--tab--qaDAg";